(function(angular){
	'use strict';
	
	var planTopQuestionsObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			allocation: '<?',
			biggerText: '<?',
			includeKOne: '<',
			planName: '<'
		},
		controller: ['APP_BASE_PATH', PlanTopQuestionsFunction],
		controllerAs: 'planTopQuestions'
	};
	
	angular
		.module('topQuestionsModule')
		.component('planTopQuestions', planTopQuestionsObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-top-questions.html';
	}
	
	function PlanTopQuestionsFunction(APP_BASE_PATH){
		var planTopQuestions = this;

		planTopQuestions.$onInit = function() {
			planTopQuestions.basePath = APP_BASE_PATH;
		};
	}
})(window.angular);